import { createApp } from "vue"
import { createPinia } from "pinia"
import { IonicVue } from "@ionic/vue"
import { VueQueryPlugin } from "@tanstack/vue-query"

import App from "@/App.vue"
import { router } from "@/router"
import { pageTransition } from "@/router/transition"
import { initOfflineListener } from "@/composables/useOffline"
import { hydrateAuth } from "@/stores/auth"
import { registerServiceWorker } from "@/composables/useServiceWorker"
import { setSessionLostHandler } from "@/api/client"

/* Ionic core CSS — required */
import "@ionic/vue/css/core.css"
import "@ionic/vue/css/normalize.css"
import "@ionic/vue/css/structure.css"
import "@ionic/vue/css/typography.css"

/* Ionic optional utilities */
import "@ionic/vue/css/padding.css"
import "@ionic/vue/css/float-elements.css"
import "@ionic/vue/css/text-alignment.css"
import "@ionic/vue/css/text-transformation.css"
import "@ionic/vue/css/flex-utils.css"
import "@ionic/vue/css/display.css"

/* Ionic dark-mode system (palette toggles via prefers-color-scheme) */
import "@ionic/vue/css/palettes/dark.system.css"

/* Orchestrated Flow palette + custom CSS */
import "@/theme/variables.css"
import "@/theme/orchestra.css"

const pinia = createPinia()
const app = createApp(App)
  .use(IonicVue, { mode: undefined, navAnimation: pageTransition })
  .use(pinia)
  .use(router)
  .use(VueQueryPlugin)

hydrateAuth()
initOfflineListener()

// When the JWT refresh fails (server-side secret rotated, account deleted,
// long-expired refresh token), the axios interceptor clears auth and asks
// the SPA to redirect to /login.
setSessionLostHandler(() => {
  if (router.currentRoute.value.name !== "login") {
    router.replace({ name: "login", query: { return_to: router.currentRoute.value.fullPath } })
  }
})

router.isReady().then(() => {
  app.mount("#app")
  registerServiceWorker()
})
